import { AnimatePresence, motion } from "motion/react";
import RegistrarCliente from "./RegistrarCliente";
import { useState } from "react";
import { IconButton } from "@mui/material";
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import ListadoClientes from "./ListadoClientes";
import PeopleAltIcon from '@mui/icons-material/PeopleAlt';
import Tooltip from "./Tooltip";

const containerVariants = {
    initial: { opacity: 0, y: 20 },
    animate: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -20 },
};

const addClienteStyle = {
    boxShadow: "none", // sombra azul translúcida
    backgroundColor: '#0a2540',   // color que quieras
    borderRadius: '50%',
    padding: '8px',
    transition: "all 0.2s ease",  // transición suave
    color: '#f5f7fa',
    "&:hover": {
        backgroundColor: "#1259a7", // color más oscuro al pasar el mouse
        boxShadow: "0px 6px 20px rgba(18, 89, 167, 0.5)",
        transform: "translateY(-3px)", // se levanta hacia arriba
    },
}

const Clientes = () => {
    const [agregarCliente, setAgregarCliente] = useState(false)

    return (
        <div className="container mt-4">
            <AnimatePresence mode="popLayout">
                <Tooltip text={agregarCliente ? 'LISTADO DE CLIENTES' : 'AGREGAR CLIENTES'} position="top">
                    <IconButton
                        className="pointer mb-3"
                        onClick={() => setAgregarCliente(!agregarCliente)}
                        sx={{
                            ...addClienteStyle,
                            width: 48,
                            height: 48,
                        }}
                    >
                        {!agregarCliente ? (
                            <GroupAddIcon />
                        ) : (
                            <PeopleAltIcon />
                        )}
                    </IconButton>
                </Tooltip>

                {agregarCliente ? (
                    <motion.div
                        key="registrar"
                        layout
                        variants={containerVariants}
                        initial="initial"
                        animate="animate"
                        exit="exit"
                        transition={{ duration: 0.35, ease: "easeOut" }}
                        style={{ width: "100%" }}
                    >
                        <RegistrarCliente />
                    </motion.div>
                ) : (
                    <motion.div
                        key="clientes"
                        layout
                        variants={containerVariants}
                        initial="initial"
                        animate="animate"
                        exit="exit"
                        transition={{ duration: 0.35, ease: "easeOut" }}
                        style={{ width: "100%" }}
                    >
                        <ListadoClientes />
                    </motion.div>
                )}

            </AnimatePresence>
        </div>
    )

}

export default Clientes